import { Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { IconBuildingBank, IconCircleCheck, IconFileCertificate } from '@tabler/icons-react';
import { useHydrated } from 'helpers/useHydrated';

import { isFhaEligible, type ListingDetails } from './listingDetails';

export const ListingAlerts = ({ listing }: { listing: ListingDetails }) => {
  const hydrated = useHydrated();
  const eligible = hydrated && isFhaEligible(listing, new Date());
  const eligibleDate = listing.fhaEligibleDate
    ? new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(new Date(`${listing.fhaEligibleDate}T00:00:00`))
    : null;
  return (
    <Col
      as="section"
      aria-label="Property alerts"
      className="gap-4 rounded-[16px] bg-od-bg-secondary p-4"
    >
      <Row className="items-start gap-3">
        <IconFileCertificate
          aria-hidden="true"
          className="size-4 shrink-0 text-od-content-secondary"
        />
        <Col className="min-w-0 gap-1">
          <Text as="h2" className="font-medium text-body-sm text-od-content-primary">
            Offer status
          </Text>
          <Text className="text-body-sm text-od-content-secondary">
            {listing.activeOfferCheckText ||
              'Offer status is unavailable. Contact the Listing Partner for an update.'}
          </Text>
        </Col>
      </Row>
      {hydrated ? (
        <Row className="items-start gap-3">
          {eligible ? (
            <IconCircleCheck
              aria-hidden="true"
              className="size-4 shrink-0 text-od-content-success"
            />
          ) : (
            <IconBuildingBank
              aria-hidden="true"
              className="size-4 shrink-0 text-od-content-secondary"
            />
          )}
          <Col className="min-w-0 gap-1">
            <Text as="h2" className="font-medium text-body-sm text-od-content-primary">
              {eligible ? 'FHA eligible' : 'FHA waiting period'}
            </Text>
            <Text className="text-body-sm text-od-content-secondary">
              {eligible
                ? 'This home is eligible for FHA financing.'
                : `Home is FHA eligible on ${eligibleDate}.`}
            </Text>
          </Col>
        </Row>
      ) : null}
    </Col>
  );
};
